import { render, staticRenderFns } from "./imageTwoGap.vue?vue&type=template&id=4bc736e5&scoped=true&"
import script from "./imageTwoGap.vue?vue&type=script&lang=js&"
export * from "./imageTwoGap.vue?vue&type=script&lang=js&"
import style0 from "./imageTwoGap.vue?vue&type=style&index=0&id=4bc736e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc736e5",
  null
  
)

export default component.exports